export const memsourceInitialFilterState = {
    name: '',
    internalId: '',
    originalName: '',
    validatorNames: [],
    sourceLanguages: [],
    targetLanguages: [],
    onTime: null,
    priceMin: '',
    priceMax: '',
    workflowStatus: [],
    creationDateFromTo: [null, null],
    dateDueFromTo: [null, null],
    jobStatus: [],
    projectJobStatus: [],
    jobState: [],
    deliveryStatus: [],
    workflowStep: [],
}
